<script>
import includes from 'lodash/includes'
import map from 'lodash/map'
import find from 'lodash/find'
import get from 'lodash/get'
import Field from './../components/Field.vue'

import EventBus from './../eventBus.js'

export default {
  name: 'campaign-dashboard',
  components: {
    Field,
  },
  props: [],
  data() {
    return {
      hasError: false,
      selectedCause: null,
      name: '',
      title: '',
      target: '',
      description: '',
      errorMsg: {
          name: {

          },

          title: {

          },

          target: {

          },

          description: {

          },

          cause: {

          }
      }
    }
  },
  mounted() {
      this.errorMsg = globalVars.campaignDashboard.errorMsg;
  },
  computed: {
      globalVars() {
          return this.$root.globalVars
      },

      nameError() {
          return this.hasError && this.name === '';
      },

      titleError() {
          return this.hasError && this.title === '';
      },

      targetError() {
          return this.hasError && (this.target === '' || isNaN(this.target));
      },

      descriptionError() {
          return this.hasError && this.description === '';
      },

      selectedCauseError() {
          return this.hasError && this.selectedCause === null;
      }
  },
  methods: {
    selectCause(cause) {
        this.selectedCause = cause;
    },

    nameLengthRestrict(evt) {
        if (this.name.length >= 10) {
            evt.preventDefault();
        }

        return true;
    },

    numberOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    submit() {
        if (this.name === '' || this.title === '' || (this.target === '' || isNaN(this.target)) || this.description === '' || this.selectedCause === null) {
            this.hasError = true;
            return false;
        }

        this.hasError = false;
        this.$refs.form.submit();
    }
  },
  watch: {

  }
}
</script>
